module.exports = __webpack_public_path__ + "img/ch-gender.20565b69.jpg";